jQuery(document).ready(function($) {

  // Read More button
  $('#read-more').click(function($e) {
    $e.preventDefault();
    $('#basic-info-obit-bio').toggleClass('active');
  });

  // TODO - toggle Read More & Close button text
  // $('#read-more').click(function($e) {
  //   $e.preventDefault();
  //
  //   $(this).text(function(i, v) {
  //     return v === 'read more' ? 'close' : 'read more'
  //   })
  // });

  // Remove active class on first nav-tab li
  jQuery('.nav-tabs li').first().removeClass('active');

})


// Nav tabs - Visitation, Service, etc
window.addEventListener("load", function() {

// store tabs variable
var myTabs = document.querySelectorAll("ul.nav-tabs > li > a");

function myTabClicks(tabClickEvent) {

  for (var i = 0; i < myTabs.length; i++) {
    myTabs[i].classList.remove("active");
  }

  var clickedTab = tabClickEvent.currentTarget;

  clickedTab.classList.add("active");

  tabClickEvent.preventDefault();

  var myContentPanes = document.querySelectorAll(".tab-pane");

  for (var i = 0; i < myContentPanes.length; i++) {
    myContentPanes[i].classList.remove("active");
  }

  var anchorReference = tabClickEvent.target;
  var activePaneId = anchorReference.getAttribute("href");
  var activePane = document.querySelector(activePaneId);

  activePane.classList.add("active");

}

for (var i = 0; i < myTabs.length; i++) {
  myTabs[i].addEventListener("click", myTabClicks)
}
});
